/* ber-footer.js — mobile accordion for ber-ft columns */
(function () {
  'use strict';

  var MOBILE_BP = 768;

  function initFooter(section) {
    if (section.dataset.berFtInit) return;
    section.dataset.berFtInit = '1';

    var triggers = section.querySelectorAll('.ber-ft__col-trigger');
    var newsletterInput = section.querySelector('.ber-ft__nl-input');
    var newsletterForm = section.querySelector('.ber-ft__nl-form');

    function syncNewsletterState() {
      if (!newsletterInput || !newsletterForm) return;
      newsletterForm.classList.toggle(
        'ber-ft__nl-form--has-value',
        newsletterInput.value.trim().length > 0
      );
    }

    if (newsletterInput && newsletterForm) {
      syncNewsletterState();
      newsletterInput.addEventListener('input', syncNewsletterState);
      newsletterInput.addEventListener('change', syncNewsletterState);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        // On desktop the trigger is decorative — do nothing
        if (window.innerWidth >= MOBILE_BP) return;

        var col = trigger.closest('.ber-ft__col--accordion');
        if (!col) return;

        var body = col.querySelector('.ber-ft__col-body');
        var isOpen = col.classList.contains('ber-ft__col--open');

        // Close any currently-open column in this footer
        section.querySelectorAll('.ber-ft__col--open').forEach(function (openCol) {
          openCol.classList.remove('ber-ft__col--open');
          openCol.querySelector('.ber-ft__col-body').style.maxHeight = '0';
          openCol.querySelector('.ber-ft__col-trigger').setAttribute('aria-expanded', 'false');
        });

        // Open this column if it was previously closed
        if (!isOpen) {
          col.classList.add('ber-ft__col--open');
          // scrollHeight includes the padding-bottom on .ber-ft__col-body-pad
          body.style.maxHeight = body.scrollHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // On resize back to desktop: clear all inline max-height and open states
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (window.innerWidth >= MOBILE_BP) {
          section.querySelectorAll('.ber-ft__col--accordion .ber-ft__col-body').forEach(function (body) {
            body.style.maxHeight = '';
          });
          section.querySelectorAll('.ber-ft__col--open').forEach(function (col) {
            col.classList.remove('ber-ft__col--open');
          });
          section.querySelectorAll('.ber-ft__col-trigger').forEach(function (t) {
            t.setAttribute('aria-expanded', 'false');
          });
        }
      }, 150);
    });
  }

  // Init on page load
  document.querySelectorAll('.ber-ft').forEach(initFooter);

  // Re-init when Shopify theme editor reloads the section
  document.addEventListener('shopify:section:load', function (e) {
    var ft = e.target.querySelector('.ber-ft');
    if (ft) initFooter(ft);
  });
})();
